import { defaultFavoriteState, KnownAction, FavoriteData, FavoriteEntry, FavoriteState } from "../store/favorite";
import { Reducer } from "@reduxjs/toolkit";
import * as ActionTypes from "../common/actionTypes";

const addFavoriteEntry = (state: FavoriteState, favoriteEntry: Omit<FavoriteEntry, 'favoriteId'>): FavoriteData => {
    const newFavoriteData = {
        favs: [...(state.data?.favs ?? [])]
    };
    
    newFavoriteData.favs = [...newFavoriteData.favs, { favoriteId: -1, ...favoriteEntry }];
    
    return { ...state.data, ...newFavoriteData };
}

const removeFavoriteEntry = (state: FavoriteState, favoriteEntryId: number): FavoriteData => {
    const newFavoriteData = {
        favs: state.data?.favs.filter(e => e.favoriteId !== favoriteEntryId) ?? []
    }
    console.log("removeFavoriteEntry: ");
    console.log(state);
    console.log(favoriteEntryId);
    console.log(newFavoriteData.favs);
    
    return { ...state.data, ...newFavoriteData };
}

export const favoriteReducer: Reducer<FavoriteState, KnownAction> = (state, action) => {
    if (state === undefined) {
        return defaultFavoriteState;
    }
    
    switch (action.type) {
        case ActionTypes.RequestCreateFavorite:
            return {
                ...state,
                isLoading: true
            };
            
        case ActionTypes.ReceiveCreateFavorite:
            return {
                ...state,
                isLoading: false,
                data: addFavoriteEntry(state, action.data),
            }
            
        case ActionTypes.RequestReadCollectionFavorite:
            return {
                ...state,
                isLoading: true
            };
            
        case ActionTypes.ReceiveReadCollectionFavorite:
            return {
                ...state,
                isLoading: false,
                data: action.data
            };
            
        case ActionTypes.RequestDeleteFavorite:
            return {
                ...state,
                isLoading: true,
                data: removeFavoriteEntry(state, action.favoriteEntryId)
            }
            
        case ActionTypes.ReceiveDeleteFavorite:
            return {
                ...state,
                isLoading: false
            }
            
        case ActionTypes.HandleErrorFavorite:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
            
        case ActionTypes.ClearErrorFavorite:
            return {
                ...state,
                error: undefined
            }
            
        default:
            return { ...state };
    }
}